import { render, staticRenderFns } from "./TypeNav.vue?vue&type=template&id=03ac24f8&scoped=true&"
import script from "./TypeNav.vue?vue&type=script&lang=js&"
export * from "./TypeNav.vue?vue&type=script&lang=js&"
import style0 from "./TypeNav.vue?vue&type=style&index=0&id=03ac24f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ac24f8",
  null
  
)

export default component.exports